/** Type of layout used in shell */
export enum LayoutType {
  Home = 'home',
  PurchasePath = 'purchasePath',
  StaticContent = 'staticContent',
}
